.fields {
    margin-top: 32px;
}

.button {
    composes: space-above from '../../auth-shared.module.css';
}

.submit {
    margin-bottom: 8px;
}

.success {
    color: var(--success);
    font-size: var(--font-normal);
}
